import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdmCustomers() {
  const [list, setList] = useState([]);
  useEffect(()=>{ api.get("/admin/customers").then(r=>setList(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">CRM</div><h1 className="font-display text-4xl text-white">Customers</h1></div>
      <div className="card-luxe overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-luxe text-white/40"><tr className="border-b border-white/5"><th className="text-left p-4">Name</th><th>Email</th><th>Phone</th><th>Orders</th><th>Lifetime</th><th>Joined</th></tr></thead>
          <tbody>
            {list.map(c => (
              <tr key={c.id} className="border-b border-white/5">
                <td className="p-4 text-white">{c.name}</td>
                <td className="text-white/70">{c.email}</td>
                <td className="text-white/50 text-xs">{c.phone||"—"}</td>
                <td>{c.orders_count}</td>
                <td className="text-copper">AED {c.lifetime_value.toLocaleString()}</td>
                <td className="text-white/50 text-xs">{c.created_at?.slice(0,10)}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-white/40">No customers yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
